import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as mealTypeActions from 'PointOfSale/modules/mealTypes/state/actions';
import MealsTypesFooterComponent from 'PointOfSale/modules/layouts/component/MealsTypesFooter';

class MealsTypesFooter extends Component {
  render() {
    const { currentSelectedMenu } = this.props;
    let enableContinue = false;
    if (currentSelectedMenu) {
      enableContinue = true
    }
    return (
      <MealsTypesFooterComponent enableContinue={enableContinue} />
    );
  }
}
MealsTypesFooter.propTypes = {
  currentSelectedMenu: PropTypes.string,
  mealTypesActions: PropTypes.shape({
    reset: PropTypes.func
  })
};
const mapStateToProps = state => ({
  currentSelectedMenu: state.PointOfSaleState.mealTypes.currentSelectedMenu
});

const mapDispatchToProps = dispatch => ({
  mealTypesActions: bindActionCreators(mealTypeActions, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MealsTypesFooter)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/container/MealsTypesFooter.js